import { Drop } from "@phosphor-icons/react";
import clsx from "clsx";

import RelativeLink from "common/components/RelativeLink";
import RenderIf from "common/components/RenderIf";
import ProfileImage from "common/components/ui/ProfileImage";
import type { RecentLead } from "common/types";

interface RecentLeadsItemProps {
  lead: RecentLead;
  openPreviewSidebar: () => void;
  originType: "flow" | "campaign";
}

const containerClassName =
  "flex items-center gap-x-3 rounded-3xl border border-black-200 bg-white px-4 py-3 transition-colors hover:bg-black-100";

export default function RecentLeadsItem({
  lead,
  originType,
  openPreviewSidebar,
}: RecentLeadsItemProps) {
  const {
    target_id,
    campaign_name: campaignName,
    target: { picture_url: pictureUrl, full_name: fullName, occupation },
    flow_name: flowName,
    is_drip: isDrip,
  } = lead;

  const content = (
    <>
      <ProfileImage src={pictureUrl} />

      <div className="flex flex-col gap-y-0.5">
        <div className="flex items-center gap-x-0.5">
          <span className="line-clamp-1 break-all text-start text-button-sm">
            {fullName}
          </span>

          <RenderIf condition={isDrip}>
            <Drop weight="fill" size={16} className="fill-blue-300" />
          </RenderIf>
        </div>

        <p className="line-clamp-1 break-all text-start text-xs text-black-500">
          {originType ? (
            <>
              Origin:{" "}
              <span className="font-semibold">
                {originType === "flow" ? flowName : campaignName}
              </span>
            </>
          ) : (
            occupation
          )}
        </p>
      </div>
    </>
  );

  return (
    <>
      <RelativeLink
        className={clsx(containerClassName, "lg:hidden")}
        to={`/leads/${target_id}`}
      >
        {content}
      </RelativeLink>
      <button
        className={clsx(containerClassName, "max-lg:hidden")}
        onClick={openPreviewSidebar}
        type="button"
      >
        {content}
      </button>
    </>
  );
}
